import { MediumInfo } from './vo/medium-info.model';
/**
 * 掲載媒体設定画面の値を管理するクラス
 *
 * @export KYMW1202Model
 * @class KYMW1202Model
 */
export class KYMW1202Model {
  public pCode = '';
  public guideGoodsName = '';
  public guideStandardName = '';

  public list: MediumInfo[] = [];
  public listOrigin: MediumInfo[] = [];

  get hasCanceledMedium() {
    return this.list.find(
      _e =>
        this.listOrigin.find(_o => _e.mediumType === _o.mediumType)?.check &&
        !_e.check
    )
      ? true
      : false;
  }

  get hasChangedMedium() {
    return this.list.find(
      _e =>
        this.listOrigin.find(_o => _e.mediumType === _o.mediumType)?.check !==
        _e.check
    )
      ? true
      : false;
  }
}
